<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-6 text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t("plan.sub") }}</span>
        <h3 class="page-title">{{ $t("payments.managepayments") }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="card-box col-lg-10 mx-auto mt-4">
        <div class="card card-small edit-user-details mb-4">
          <div class="card-body p-0">
            <div class="clearfix d-flex">
              <div class="nav px-4 pricing-top">
                <d-link to="/plan">
                  <div class="btn btn-primary pt-2 current-plan-box ml-2">
                    {{ currentPlan }}
                  </div>
                </d-link>
                <div class="current-plan-name">
                  <span class="current-plan-title font-weight-bold">{{
                    $t("payments.currentplan")
                  }}</span>
                  <p class="current-plan-subtitle">
                    ${{ planPrice }} /
                    {{
                      planPrice === "199.99"
                        ? $t("payments.month")
                        : $t("payments.year")
                    }}
                  </p>
                </div>
              </div>
            </div>
            <!-- Card Area -->
            <article
              class="card"
              v-if="getCurrentUser && getCurrentUser.stripeCustomerId"
            >
              <div class="card-body p-5">
                <div class="current-payment-box row">
                  <div class="sizer-card col-lg-12">
                    <div class="current-card row">
                      <div class="card-shape mr-auto">
                        <img
                          v-if="
                            getCardInfo && getCardInfo.brand === 'mastercard'
                          "
                          src="@/assets/images/card-logo/mastercard.svg"
                          alt="card type"
                        />
                        <img
                          v-if="getCardInfo && getCardInfo.brand === 'visa'"
                          src="@/assets/images/card-logo/visa.svg"
                          alt="card type"
                        />
                        <img
                          v-if="getCardInfo && getCardInfo.brand === 'jcb'"
                          src="@/assets/images/card-logo/jcb.svg"
                          alt="card type"
                        />
                        <img
                          v-if="
                            getCardInfo && getCardInfo.brand === 'diners-club'
                          "
                          src="@/assets/images/card-logo/diners-club.svg"
                          alt="card type"
                        />
                        <img
                          v-if="getCardInfo && getCardInfo.brand === 'discover'"
                          src="@/assets/images/card-logo/discover.svg"
                          alt="card type"
                        />
                      </div>
                      <div class="card-name font-weight-bold">
                        {{ getCardInfo.brand | capitalize }}
                      </div>
                      <div class="card-number">
                        XXXX XXXX XXXX {{ getCardInfo.last4 }}
                      </div>
                      <div class="valid-till">
                        Expires:
                        {{
                          `${getCardInfo.exp_month} / ${getCardInfo.exp_year}`
                        }}
                      </div>
                    </div>
                  </div>
                  <!-- Card Details
                  <div class="sizer pl-4 col-lg-12">
                    <div class="details">
                      <div class="title">
                        <span class="text-muted">{{ $t("payments.name") }}:</span>
                        {{ cardName }}
                      </div>
                      <div class="title">
                        <span class="text-muted">{{ $t("payments.address") }}:</span>
                        {{ cardAddress }}
                      </div>
                      <div class="title">
                        <span class="text-muted">{{ $t("payments.vat") }}:</span>
                        {{ vat }}
                      </div>
                    </div>
                    <div class="row col-lg-12">
                      <u class="edit-card font-sm">
                        <span class="font-weight-bold">
                          <d-link
                            to="/billing"
                            class="underline mt-1 cursor"
                          >{{ $t("payments.editcard") }}</d-link>
                        </span>
                        <span class="font-weight-bold">
                          <d-link
                            to="/invoices"
                            class="ml-3 underline mt-1 cursor"
                          >{{ $t("payments.viewinvoices") }}</d-link>
                        </span>
                      </u>
                    </div>
                  </div>
                  -->
                  <d-button
                    :disabled="true"
                    class="btn-danger btn ml-4 cancel-btn"
                    >{{ $t("payments.cancelplan") }}</d-button
                  >
                  <div class="row">
                    <p class="col-10 ml-4 x-4 mt-3">
                      {{ $t("payments.cancelnote") }}
                      <a href="/terms">{{ $t("payments.terms") }}.</a>
                    </p>
                  </div>

                  <!-- End Card Details -->
                </div>
              </div>
            </article>
          </div>

          <!-- End Card Area -->
        </div>
      </div>
    </div>
  </d-container>
</template>

<script>
import { mapGetters } from "vuex";
import { USER_CARD_INFO } from "@/store/types";

export default {
  computed: {
    ...mapGetters(["getCurrentUser", "getCardInfo"]),
    currentPlan() {
      if (this.getCurrentUser) {
        return this.getCurrentUser.premium ? "Pro" : "Free";
      }
      return "Free";
    },
    planPrice() {
      if (this.getCurrentUser && this.getCurrentUser.currentPlan) {
        return this.getCurrentUser.currentPlan === "month"
          ? "199.99"
          : "1999.99";
      }
      return "0.00";
    }
  },
  watch: {
    getCurrentUser(val) {
      if (this.getCurrentUser && this.getCurrentUser.stripeCustomerId) {
        this.$store.dispatch(USER_CARD_INFO).then(resp => console.log(resp));
      }
    }
  },
  data() {
    return {
      cardType: "Mastercard",
      lastFour: "1234",
      expDate: "02/2025",
      vat: "AO1234567",
      cardName: "John Smith",
      cardAddress: "123 Hollyberry ln., New York NY"
    };
  }
};
</script>

<style lang="scss" scoped>
.card-box {
  max-width: 750px;
}

.cancel-btn {
  font-size: 15px !important;
  padding: 6px 20px 10px 20px;
  height: 30px;
}
</style>
